/**
 * Normalizes pickup window labels to an en dash between times (e.g. 11:00–11:05).
 * @param {string|null|undefined} pickupWindow
 * @returns {string}
 */
export function formatPickupWindowLabel(pickupWindow) {
  if (pickupWindow == null || pickupWindow === "") return "";
  return String(pickupWindow).replace(/\s*[-–—]\s*/g, "\u2013");
}

/**
 * Customer-facing drive pickup time: the end of the 5-minute slot.
 * "11:00 - 11:05" → "11:05". A single clock time is returned unchanged.
 * @param {string|null|undefined} pickupWindow
 * @returns {string}
 */
export function pickupWindowEndLabel(pickupWindow) {
  const normalized = formatPickupWindowLabel(pickupWindow);
  if (!normalized) return "";
  const parts = normalized.split("\u2013").map((part) => part.trim()).filter(Boolean);
  const end = parts.length >= 2 ? parts[parts.length - 1] : parts[0];
  const match = String(end || "").match(/^(\d{1,2}):(\d{2})$/);
  if (!match) return normalized;
  return `${String(Number(match[1])).padStart(2, "0")}:${match[2]}`;
}
